/* unplugin-vue-components disabled */import { render } from "./FormIndustry.vue?vue&type=template&id=62cb958c&ts=true"
import script from "./FormIndustry.vue?vue&type=script&lang=ts"
export * from "./FormIndustry.vue?vue&type=script&lang=ts"

import "./FormIndustry.vue?vue&type=style&index=0&id=62cb958c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__